export default $axios => ({
  fetch(params) {
    return $axios.$get('/v2/localized-slugs', { params })
  },
  getServiceName: () => 'localizedSlugService',
})
